import './Loader.style.scss'
export const Loader = () => {
  return (
    <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  )
}